import { ComponentBase } from "@tblabs/truffle";
import { StepState } from "../Models/StepState";
import { MarkedStep } from "../Models/MarkedStep";


export class StepStylist
{
    public Style(markedStep: MarkedStep, stepBox: ComponentBase<any>): void
    {
        if (markedStep.IsCurrent)
        {
            stepBox.AddClass("active");
        }

        if (markedStep.State == StepState.Failed)
            stepBox.BorderColor("#ffa2a2").BorderWidth(4);

        if (markedStep.IsBeforeCurrent)
        {
            if (markedStep.Step.IsWellDone)
                stepBox.BorderColor("#16cf74").BorderWidth(2);
        }

        if (markedStep.IsAfterCurrent)
        {
            stepBox.Opacity(0.5);
        }
    }
}
